// extracted by mini-css-extract-plugin
export var label = "_i7-0";
export var treatmentCard = "_i7-1";